import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import moment from 'moment-timezone';
import SaveIcon from '@mui/icons-material/Save';

import api from '../../../services/api'
import socket from '../../../services/socket';

import {
  CircularProgress
} from "@mui/material"

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'date', numeric: false, disablePadding: true, label: 'Data' },
  { id: 'hour', numeric: true, disablePadding: false, label: 'Horário' },
  { id: 'seller', numeric: true, disablePadding: false, label: 'Vendedor' },
  { id: 'conversion', numeric: true, disablePadding: false, label: 'Conversão' },
  { id: 'value', numeric: true, disablePadding: false, label: 'Valor' },
  { id: 'items', numeric: true, disablePadding: false, label: 'Itens' },
  { id: 'reason', numeric: false, disablePadding: false, label: 'Motivo' },
  { id: 'product', numeric: false, disablePadding: false, label: 'Produto' }
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
          color: theme.palette.primary.main,
          backgroundColor: lighten(theme.palette.primary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.primary.light,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { date,store_id, setIsLoading, sales,setSales,numSelected,selected,setSelected,setToEdit,toEdit,sellers,nocReasons,products,toDelete,setToDelete } = props;
  const handleDelete = ()=>{
    let id = selected[0].id
    let salesCopy = sales.filter(sale => sale.id !== id)
    let selectedCopy = selected.filter(sale => sale.id !== id)
    setSales(salesCopy)
    setToDelete([...toDelete,id])
    setSelected(selectedCopy) 
    return 
  }

  async function sendDataHttp(e){
    try{
      let data = { 
        'store_id': store_id,
        'edit':toEdit,
        'delete':toDelete
      }
      // const token = await sessionStorage.getItem('token')
      await api.post('/vezo/lastevents/sendData/'+store_id,data);
      setIsLoading(false)
      alert("Atualizado com sucesso!")
      setToDelete([])
      setToEdit([])
      setSelected([])
      socket.emit('/vezo/lastevents/askLastEvents',{ 
        'store_id': store_id,
        'date': date
      }
      ,(data)=>{console.log(data);})
  
      socket.emit('/vezo/lastevents/askSellers',{ 
        'store_id': store_id,
      }
      ,(data)=>{console.log(data);})
  
      socket.emit('/vezo/lastevents/askInfos',{ 
        'store_id': store_id,
      }
      ,(data)=>{console.log(data);})
    }
    catch(err){
      setIsLoading(false)
      alert("Atualizado com sucesso!")
      setToDelete([])
      setToEdit([])
      setSelected([])
      socket.emit('/vezo/lastevents/askLastEvents',{ 
        'store_id': store_id,
        'date': date
      }
      ,(data)=>{console.log(data);})
  
      socket.emit('/vezo/lastevents/askSellers',{ 
        'store_id': store_id,
      }
      ,(data)=>{console.log(data);})
  
      socket.emit('/vezo/lastevents/askInfos',{ 
        'store_id': store_id,
      }
      ,(data)=>{console.log(data);})
    }
  }

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<SaveIcon />}
          onClick={sendDataHttp}
      >
          Salvar
      </Button>
      <Tooltip title="Para editar alguma venda, clique sobre ela e clique em editar!">
        <IconButton aria-label="Selecionar" size="large">
          <InfoIcon />
        </IconButton>
      </Tooltip>
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected>1?"Selecionados":"Selecionado"}
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          Vendedor
        </Typography>
      )}
      {numSelected > 0 ?       
      ( 
        numSelected>1?
        (
          null
        )
        :
        <>
          <Button onClick={handleDelete} variant="outlined" color="primary">Excluir</Button>
          <Tooltip title="Editar">
            <DialogSelect sales={sales} setSales={setSales} toEdit={toEdit} setToEdit={setToEdit} selected={selected} setSelected={setSelected} sellers={sellers} nocReasons={nocReasons} products={products}/>
          </Tooltip>
        </>
      ) : ( 
        <Tooltip title="Selecionar vendas!">
          <Button variant="outlined" color="primary"    
            onClick={() => { 
              alert('Selecionar vendas!') 
            }}>
            Editar
          </Button>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableRow: {
    "&$selected, &$selected:hover": {
      backgroundColor: lighten(theme.palette.primary.light, 0.5)
    }
  },
  tableCell: {
    "$selected &": {
      color: lighten(theme.palette.primary.light, 0.5)
    }
  },
  selected: {},
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
}));


function DialogSelect(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState(props.selected[0].date);
  const [hour, setHour] = React.useState(props.selected[0].hour);
  const [seller, setSeller] = React.useState(props.selected[0].seller);
  const [conversion, setConversion] = React.useState(props.selected[0].conversion);
  const [value, setValue] = React.useState(props.selected[0].value);
  const [items, setItems] = React.useState(props.selected[0].items);
  const [reason, setReason] = React.useState(props.selected[0].reason);
  const [product, setProduct] = React.useState(props.selected[0].product);
  const [id] = React.useState(props.selected[0].id);

  const {sales,setSales,toEdit,setToEdit,selected,setSelected} = props

  const handleChangeDate = (event) => {
    setDate(event.target.value || '');
  };

  const handleChangeHour = (event) => {
    setHour(event.target.value || '');
  };

  const handleChangeSeller = (event) => {
    setSeller(event.target.value || '');
  };

  const handleChangeConversion = (event) => {
    if(event.target.value === 0){
      setValue(0)
      setItems(0)
    }
    setConversion(event.target.value || '');
  };

  const handleChangeValue = (event) => {
    setValue(event.target.value || '');
  };

  const handleChangeItems = (event) => {
    setItems(event.target.value || '');
  };

  const handleChangeInfo = (event) => {
    setReason(event.target.value);
  };

  const handleChangeProduct = (event) => {
    setProduct(event.target.value);
  };

  const handleCloseOK = (event) => {
    let toEditTemp = toEdit.slice()
    // Ver se já tem este id dentro do ToEdit, se tiver exclui e põe o novo
    let index = toEditTemp.findIndex(sale => sale.id === id)
    if(index!==-1){
      toEditTemp.splice(index,1,{id,date,hour,seller,conversion,value,items,reason,product})
    }
    else{
      toEditTemp.push({id,date,hour,seller,conversion,value,items,reason,product})
    }
    
    setToEdit(toEditTemp)
    // Mudar valores dentro de sales, com os novos valores
    let indexTemp = sales.findIndex(sale => String(sale.id) === String(id))
    let salesCopy = sales.slice()
    salesCopy.splice(indexTemp,1,{id,date,hour,seller,conversion,value,items,reason,product})
    setSales(salesCopy)

    //deselecionar
    let selectedCopy = selected.filter(sale => sale.id !== id)
    setSelected(selectedCopy) 
    handleClose()
  }
     
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button onClick={handleClickOpen} variant="outlined" color="primary" >Editar</Button>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle>Editar</DialogTitle>
        <DialogContent>
          <form className={classes.container}>
            <div>
              <TextField
                id="date"
                label="Data"
                type="date"
                defaultValue= {moment(new Date()).format()}
                value={date}
                onChange={handleChangeDate}
                className={classes.textField}
                // variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                size="small"
              />
              <TextField
                id="time"
                label="Hora"
                type="time"
                value={hour}
                onChange={handleChangeHour}
                // variant="outlined"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
                size="small"
                
              />
            </div>
            <div>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Vendedor</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={seller}
                  onChange={handleChangeSeller}
                >
                  {props.sellers.map((seller)=>{
                    return(
                    <MenuItem value={seller.id}>{seller.name}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Conversão</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={conversion}
                  onChange={handleChangeConversion}
                >
                  <MenuItem value={"0"}>{"0"}</MenuItem>
                  <MenuItem value={"1"}>{"1"}</MenuItem> 
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Infomação</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={reason}
                  onChange={handleChangeInfo}
                >
                  <MenuItem value={null}>{"**Nulo**"}</MenuItem>
                  {props.nocReasons.map((reason)=>{
                    return(
                    <MenuItem value={reason.id}>{reason.reason}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Produtos</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={product}
                  onChange={handleChangeProduct}
                >
                  <MenuItem value={null}>{"**Nulo**"}</MenuItem>
                  {props.products.map((product)=>{
                    return(
                    <MenuItem value={product.id}>{product.product}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </div>
            <div>
              <TextField
              id="filled-number"
              label="Valor"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              value={value}
              onChange={handleChangeValue}
              />
              <TextField
                id="filled-number"
                label="Ítens"
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                value={items}
                onChange={handleChangeItems}
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button 
            onClick={handleCloseOK} 
            color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default function LastEvents(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('Vendas');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  ////////////////////////////////////////////////////
  const [sales,setSales] = React.useState([])
  const [sellers,setSellers] = React.useState([])
  const [nocReasons,setNocReasons] = React.useState([])
  const [products, setProducts] = React.useState([])
  const [isLoading,setIsLoading] = useState(true);
  const [toDelete,setToDelete] = React.useState([])
  const [toEdit,setToEdit] = React.useState([])
  const [store_id] = React.useState(props.store_id)
  const [date] = React.useState(props.date)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect( () => {    
        setIsLoading(true)
        ////////////////////////////////////////////////////////
        function askLastEvents(){
            socket.emit('/vezo/lastevents/askLastEvents',{ 
                            'store_id': store_id,
                            'date': date,
                            'len':'0'
                        }
                        ,(data)=>{console.log(data);})
        }
        function askSellers(){
            socket.emit('/vezo/lastevents/askSellers',{ 
                            'store_id': store_id,
                        }
                        ,(data)=>{console.log(data);})
        }

        function askInfos(){
            socket.emit('/vezo/lastevents/askInfos',{ 
                            'store_id': store_id,
                        }
                        ,(data)=>{console.log(data);})
        }

        function askProducts(){
          socket.emit('/vezo/lastevents/askProducts',{ 
                          'store_id': store_id,
                      }
                      ,(data)=>{console.log(data);})
        }
        //////////////////////////////////////////////////////////
        async function loadaskLastEvents(){
            askLastEvents()
            socket.on('/vezo/lastevents/updateLastEvents/'+store_id,()=>{
                askLastEvents();
            })
            socket.on('/vezo/lastevents/LastEventsInformation/'+store_id,(data)=>{
                setSales(data)
            });
            return () => socket.disconnect();
        }

        async function loadaskSellers(){
            askSellers()
            socket.on('/vezo/lastevents/updateSellers/'+store_id,()=>{
                askSellers();
            })
            socket.on('/vezo/lastevents/LastEventsSellers/'+store_id,(data)=>{
                setSellers(data)
            });
            return () => socket.disconnect();
        }

        async function loadaskInfos(){
            askInfos()
            socket.on('/vezo/lastevents/updateInfos/'+store_id,()=>{
                askInfos();
            })
            socket.on('/vezo/lastevents/LastEventsInfos/'+store_id,(data)=>{
                setNocReasons(data)
            });
            return () => socket.disconnect();
        }

        async function loadaskProducts(){
          askProducts()
          // socket.on('/vezo/lastevents/updateProducts/'+store_id,()=>{
          //   askProducts();
          // })
          socket.on('/vezo/lastevents/LastEventsProducts/'+store_id,(data)=>{
              setProducts(data)
          });
          return () => socket.disconnect();
        }
        //////////////////////////////////////////////////////////////
        loadaskLastEvents(); 
        loadaskSellers();
        loadaskInfos();
        loadaskProducts();
  },[props,date,store_id]);


  useEffect(()=>{
    function askLastEvents(){
      socket.emit('/vezo/lastevents/askLastEvents',{ 
                      'store_id': store_id,
                      'date': date,
                      'len':String(sales.length)
                  }
                  ,(data)=>{console.log(data);})
    }

    async function loadaskLastEvents(){
      askLastEvents()
      // socket.on('/vezo/lastevents/updateLastEvents/'+store_id,()=>{
      //     askLastEvents();
      // })
      socket.on('/vezo/lastevents/LastEventsInformation/'+store_id,(data)=>{
          setSales(sales.concat(data))
      });
      return () => socket.disconnect();
    }
    if(((page+1)*rowsPerPage/sales.length)>0.5){
      loadaskLastEvents(); 
    }
    // eslint-disable-next-line
  },[page,rowsPerPage]) 

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(sales);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, sales.length - page * rowsPerPage);
  useEffect( () => {    
    if(sales.length && nocReasons.length && sellers.length && products.length){
      setIsLoading(false)
    }
  }
  ,[sales,sellers,nocReasons,products])



  return (isLoading) ?
  <div style={{paddingTop:'10px'}}>
    <CircularProgress />
  </div>
  :
  <div className={classes.root}>
    <Paper className={classes.paper}>
      <EnhancedTableToolbar store_id={store_id} date={date} setIsLoading={setIsLoading} sales={sales} setSales={setSales} numSelected={selected.length} sellers={sellers} nocReasons={nocReasons} products={products} selected={selected} setSelected={setSelected} setToEdit={setToEdit} toEdit={toEdit} setToDelete={setToDelete} toDelete={toDelete}/>
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={sales.length}
          />
          <TableBody>
            {stableSort(sales, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const isItemSelected = isSelected(row);
                const labelId = `enhanced-table-checkbox-${index}`;
                let seller = sellers.find((seller)=> String(seller.id) === String(row.seller))
                let reason = nocReasons.find((reason)=> String(reason.id) === String(row.reason))
                let product = products.find((product)=> String(product.id) === String(row.product))
                if(!reason){
                  reason = {"reason":null}
                }
                if(!product){
                  product = {"product":null}
                }
                return (
                  <TableRow
                    hover
                    onClick={(event) => handleClick(event, row)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    classes={{ selected: classes.selected }}
                    className={classes.tableRow}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        inputProps={{ 'aria-labelledby': labelId }}
                      />
                    </TableCell>
                    <TableCell component="th" id={labelId} scope="row" padding="none">
                      {row.date}
                    </TableCell>
                    <TableCell align="right">{row.hour}</TableCell>
                    <TableCell align="right">{seller.name}</TableCell>
                    <TableCell align="right">{row.conversion}</TableCell>
                    <TableCell align="right">{row.value}</TableCell>
                    <TableCell align="right">{row.items}</TableCell>
                    <TableCell align="right">{reason.reason}</TableCell>
                    <TableCell align="right">{product.product}</TableCell>
                  </TableRow>
                );
              })}
            {emptyRows > 0 && (
              <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage = "Linhas"
        component="div"
        count={sales.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  </div>;



}